import { render, staticRenderFns } from "./forgetpwd.vue?vue&type=template&id=c895c74e&scoped=true&"
import script from "./forgetpwd.vue?vue&type=script&lang=js&"
export * from "./forgetpwd.vue?vue&type=script&lang=js&"
import style0 from "./forgetpwd.vue?vue&type=style&index=0&id=c895c74e&lang=less&scoped=true&"
import style1 from "./forgetpwd.vue?vue&type=style&index=1&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c895c74e",
  null
  
)

export default component.exports